export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["číslo"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jméno"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zrušit"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložit"])}
}